import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import ViewLanguages from "@/shared/components/ViewLanguages/ViewLanguages";
import { useDeviceDetect } from "@/shared/hooks/useDeviceDetect";
import DropDown from "@/shared/components/DropDown/DropDown";

import { getOptionKey } from "@/shared/utils/select";

import styles from "./LanguageSelector.module.scss";

/*const DropDown = dynamic(() => import("@/shared/components/DropDown/DropDown"), {
  ssr: true,
});*/

const LanguageSelector = ({
  toggleOnClickButton,
  isRenderBodyWhenSSR,
  isUseLockBodyScroll,
  withCheckbox,
  hideOnClick,
  title,
  langs,
  currentLang,
  className,
  classNameButton,
  onClickLanguage,
  button,
  toggleOnMouseOverLeave,
  onShow,
  onHide,
  popupProps,
}) => {
  const { isRealMobile } = useDeviceDetect();

  const isValueArray = Array.isArray(currentLang);

  const selectButton = button
    ? button
    : ({ onClick, ref }) => (
        <span tabIndex={0} ref={ref} onClick={onClick} className={classNameButton}>
          {title}
        </span>
      );

  return (
    <DropDown
      onShow={onShow}
      isMaxWidthBasedOnButton={false}
      isRenderBodyWhenSSR={isRenderBodyWhenSSR}
      isUseLockBodyScroll={isUseLockBodyScroll}
      toggleOnMouseOverLeave={toggleOnMouseOverLeave}
      toggleOnClickButton={toggleOnClickButton}
      className={classNames(styles["language-selector"], className)}
      onHide={() => {
        if (onHide) {
          onHide();
        }
      }}
      popupProps={{
        hasConstantSizes: true,
        usePositionAbsolute: isRealMobile,
        hideOnScroll: false,
        maxHeight: () => ("window" in global ? window.innerHeight / 2 : undefined),
        contentProps: {
          className: styles["language-selector__inner"],
        },
        ...popupProps,
      }}
      button={selectButton}
      body={({ hide }) => (
        <ViewLanguages
          isHideCheckbox={!withCheckbox}
          items={langs}
          itemsChecked={isValueArray ? currentLang : [currentLang]}
          onClickItem={(e, item) => {
            onClickLanguage(getOptionKey(item));

            if (hideOnClick) {
              hide(e);
            }
          }}
        />
      )}
    />
  );
};

LanguageSelector.defaultProps = {
  hideOnClick: true,
  toggleOnMouseOverLeave: true,
};

LanguageSelector.propTypes = {
  isRenderBodyWhenSSR: PropTypes.bool,
  isUseLockBodyScroll: PropTypes.bool,
  toggleOnMouseOverLeave: PropTypes.bool,
  hideOnClick: PropTypes.bool,
  withCheckbox: PropTypes.bool,
  title: PropTypes.node,
  button: PropTypes.func,
  langs: PropTypes.array,
  currentLang: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  className: PropTypes.string,
  classNameButton: PropTypes.string,
  onClickLanguage: PropTypes.func.isRequired,
};

export default LanguageSelector;
